import axios from 'axios'

import { type CoreStoreDomainStatus } from '@flecto/types'

/**
 * Delete an existing (or not) domain config and details, through a local proxy.
 *
 * @endpoint POST /api/stores/domains/remove
 * @scope saas (local proxy)
 */
export async function deleteStoreCustomDomain(domain: string): Promise<CoreStoreDomainStatus> {
  const res = await axios.post('/api/stores/domains/remove', { domain })

  return res.data
}
